import React from 'react';
import { PTestQuestion } from '../../onboarding.service';
import { PTestAnswerType } from '../../../user/user.type';

import styles from './onboarding-step-p-test.module.css';

type OnboardingStepPTestUiProps = {
  testQuestions: PTestQuestion[],
  testAnswers: PTestAnswerType[],
  loading: boolean,
  error: string | null,
  stepErrors: boolean,
  onUpdateAnswer: (questionId: string, answer: string) => void,
}

const OnboardingStepPTestUi = ((props: OnboardingStepPTestUiProps) => {
  const {
    testQuestions,
    testAnswers,
    loading,
    error,
    stepErrors,
    onUpdateAnswer,
  } = props;

  const getCurrentAnswer = (questionId: string): string | null => {
    const answer = testAnswers.find(a => a.questionId === questionId);
    return answer ? answer.answer.toString() : null;
  };

  if (loading) {
    return <div className={styles.loading}>Loading questions...</div>;
  }

  if (error) {
    return <div className={styles.error}>{error}</div>;
  }

  return (
    <div className={styles.layout}>
      {testQuestions.map((question) => {
        const questionId = question.id!;
        const currentAnswer = getCurrentAnswer(questionId);

        return (
          <div key={questionId} className={styles.question}>
            <div className={styles.questionText}>
              {question.question}
            </div>

            <div className={styles.answerOptions}>
              {['1', '2', '3', '4', '5'].map((option) => {
                const isSelected = currentAnswer === option;
                return (
                  <button
                    key={option}
                    type="button"
                    className={`${styles.answerButton} ${isSelected ? styles.selected : ''}`}
                    onClick={() => onUpdateAnswer(questionId, option)}
                  >
                    {option}
                  </button>
                );
              })}
            </div>

            <div className={styles.answerLabels}>
              <span className={styles.disagreeLabel}>Strongly Disagree</span>
              <span className={styles.agreeLabel}>Strongly Agree</span>
            </div>

            {stepErrors && !currentAnswer && (
              <div className={styles.errorText}>Please select an answer</div>
            )}
          </div>
        );
      })}
    </div>
  );
});

export default OnboardingStepPTestUi;
